import { useTranslation } from 'react-i18next';

import { useAccountActionContext } from '../_context/useAccountActionContext';

interface Props {
  isPendingDowngrade: boolean;
  isProratedDowngradeAvailable: boolean;
}

const useDowngradeSubscription = ({ isPendingDowngrade, isProratedDowngradeAvailable }: Props) => {
  const { t } = useTranslation('', { keyPrefix: 'account_actions.downgrade' });

  const {
    isPremiumTier,
    publicationIsPrivate,
    publicationRequiresSubscriberApproval,
    canUnsubscribe,
    canDowngrade,
    isLoggedIn,
  } = useAccountActionContext();

  const descriptionParts = [];

  if (canUnsubscribe) {
    if (isPendingDowngrade || !isPremiumTier) {
      descriptionParts.push(t('unsubscribe_free_description'));
    } else {
      descriptionParts.push(t('unsubscribe_premium_description'));
    }
  } else if (!isLoggedIn) {
    descriptionParts.push(t('unsubscribe_login_description'));
  }

  if (publicationIsPrivate) {
    descriptionParts.push(t('unsubscribe_is_private'));
  } else if (publicationRequiresSubscriberApproval) {
    descriptionParts.push(t('unsubscribe_requires_approval'));
  }

  if (canDowngrade && !isPendingDowngrade) {
    descriptionParts.push(
      isProratedDowngradeAvailable ? t('downgrade_prorated_description') : t('downgrade_immediately_description'),
    );
  }

  return descriptionParts.join(' ');
};

export default useDowngradeSubscription;
